(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('AppointmentTypeSearch', AppointmentTypeSearch);

    AppointmentTypeSearch.$inject = ['$resource'];

    function AppointmentTypeSearch($resource) {
        var resourceUrl =  'api/_search/appointment-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
